export default __webpack_public_path__ + "static/media/icon_portal_on.2d305be6.svg";